// extracted by mini-css-extract-plugin
export default {"input-message":"InputMessage_input-message__5A7EE","error-icon":"InputMessage_error-icon__Zfnk+"};